import { render, staticRenderFns } from "./CommonBroadcast.vue?vue&type=template&id=24dcb568&scoped=true"
import script from "./CommonBroadcast.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonBroadcast.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CommonBroadcast.vue?vue&type=style&index=0&id=24dcb568&prod&lang=css"
import style1 from "./CommonBroadcast.vue?vue&type=style&index=1&id=24dcb568&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dcb568",
  null
  
)

export default component.exports